/**
 * @file NoContextPage.tsx
 * @description Страница «у юзера нет ни одного контекста» (phase08.5 shadcn;
 * phase19.29 — тема и логотип Commora через CommoraAuthShell).
 */

import { useNavigate } from "react-router";

import { CommoraAuthShell } from "../components/brand/CommoraAuthShell";
import { EditorialCard } from "../components/ui/EditorialCard";
import { Button } from "../components/ui/button";
import { useAuth } from "../auth/hooks";

export function NoContextPage() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  async function onLogout() {
    await logout();
    navigate("/login", { replace: true });
  }

  return (
    <CommoraAuthShell tabTitle="Нет доступных кабинетов">
      <EditorialCard floating className="w-full">
        <EditorialCard.Body>
          <div className="flex flex-col gap-4 items-center text-center">
            <h1 className="type-page-title text-on-surface">
              Нет доступных кабинетов
            </h1>
            <p className="text-sm text-on-surface-variant">
              У вашей учётной записи пока нет доступа ни к одному кабинету. Обратитесь к
              администратору платформы или магазина, чтобы получить доступ.
            </p>
            <Button variant="outline" onClick={() => void onLogout()}>
              Выйти из аккаунта
            </Button>
          </div>
        </EditorialCard.Body>
      </EditorialCard>
    </CommoraAuthShell>
  );
}
